module.exports = __webpack_public_path__ + "static/media/YM48_3.eae343d5.jpg";